/* global BigInt */
const proprio = (obj, campo) => Object.prototype.hasOwnProperty.call(obj || {}, campo);
export const booleanoFinanceiro = (v) => v === true || v === 1 || v === '1' || v === 'true';
export function aceitaPreFinanceiro(dados, operacao, parametros) {
    return (
        !dados?.id &&
        operacao?.sigla === 'XML' &&
        parametros?.tipo === 'Pagar' &&
        booleanoFinanceiro(parametros?.geraFinanceiro) &&
        !booleanoFinanceiro(dados?.custo) &&
        !booleanoFinanceiro(dados?.custoFilial) &&
        !dados?.cobrancaCondominialId &&
        !booleanoFinanceiro(parametros?.almocoColaboradorGeraFinanceiro)
    );
}
export function centavosDigitados(valor) {
    if (!['string', 'number'].includes(typeof valor)) throw new Error('Informe um valor válido.');
    let s = String(valor).trim();
    if (s.includes(',')) {
        if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+),\d{1,2}$/.test(s)) throw new Error('Valor inválido. Use, por exemplo, 125,50.');
        s = s.replace(/\./g, '').replace(',', '.');
    }
    if (!/^\d{1,8}(?:\.\d{1,2})?$/.test(s)) throw new Error('Valor inválido. Use no máximo duas casas decimais.');
    const [inteiro, decimal = ''] = s.split('.');
    const total = BigInt(inteiro) * 100n + BigInt(decimal.padEnd(2, '0'));
    if (total > 9999999999n) throw new Error('Valor acima do limite do lançamento.');
    return total;
}
export const decimalFinanceiro = (cents) => `${cents / 100n}.${String(cents % 100n).padStart(2, '0')}`;
export const valorParaCampo = (cents) => decimalFinanceiro(cents).replace('.', ',');
export function dataFinanceira(v) {
    if (typeof v !== 'string' || !/^[1-9]\d{3}-\d{2}-\d{2}$/.test(v)) throw new Error('Informe um vencimento válido.');
    const d = new Date(`${v}T00:00:00.000Z`);
    if (!Number.isFinite(d.getTime()) || d.toISOString().slice(0, 10) !== v)
        throw new Error('Vencimento inexistente no calendário.');
    return v;
}
export function resumirParcelas(parcelas, total) {
    const esperado = centavosDigitados(total);
    const soma = parcelas.reduce((acc, p) => acc + centavosDigitados(p.valor), 0n);
    return { total: esperado, soma, diferenca: esperado - soma };
}
export function sugerirParcelas({
    total,
    quantidade,
    primeiraDataVencimento,
    diasEntreParcelas,
    fixaDiaVencimento,
    credito,
    diaVencimento,
}) {
    const n = Number(quantidade);
    if (!Number.isInteger(n) || n < 1 || n > 120) throw new Error('O prazo precisa ter entre 1 e 120 parcelas.');
    const cents = centavosDigitados(total);
    if (cents < BigInt(n)) throw new Error('O total não permite parcelas positivas nessa quantidade.');
    const primeira = new Date(`${dataFinanceira(primeiraDataVencimento)}T00:00:00.000Z`);
    const mensal = booleanoFinanceiro(fixaDiaVencimento) || booleanoFinanceiro(credito);
    const dias = Number(diasEntreParcelas ?? 0);
    const dia = diaVencimento === '' || diaVencimento == null ? primeira.getUTCDate() : Number(diaVencimento);
    if (mensal && (!Number.isInteger(dia) || dia < 1 || dia > 31)) throw new Error('Dia de vencimento inválido.');
    if (!mensal && (!Number.isInteger(dias) || dias < 0 || dias > 36500)) throw new Error('Intervalo de parcelas inválido.');
    const base = cents / BigInt(n),
        sobra = cents % BigInt(n);
    return Array.from({ length: n }, (_, i) => {
        let d = new Date(primeira);
        if (i && mensal) {
            d = new Date(Date.UTC(primeira.getUTCFullYear(), primeira.getUTCMonth() + i, 1));
            const ultimo = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
            d.setUTCDate(Math.min(dia, ultimo));
        } else if (i) d.setUTCDate(primeira.getUTCDate() + dias * i);
        const dataVencimento = dataFinanceira(d.toISOString().slice(0, 10));
        return { valor: valorParaCampo(base + (BigInt(i) < sobra ? 1n : 0n)), dataVencimento, codBarraPIX: '' };
    });
}
export function montarPreFinanceiroPayload(movimento, operacao, parametros) {
    if (!proprio(movimento, 'preFinanceiro')) return undefined;
    if (movimento.id) throw new Error('Não envie novas parcelas para um movimento já salvo. Reabra o cadastro.');
    if (!aceitaPreFinanceiro(movimento, operacao, parametros))
        throw new Error('A operação atual não permite parcelas personalizadas. Revise ou desative a opção na aba Lançamentos.');
    const pre = movimento.preFinanceiro;
    if (pre?.preparando) throw new Error('Aguarde a preparação das parcelas antes de salvar.');
    if (!pre || pre.versao !== 1 || !Array.isArray(pre.parcelas) || pre.parcelas.length < 1 || pre.parcelas.length > 120) {
        throw new Error('Prepare entre 1 e 120 parcelas na aba Lançamentos.');
    }
    const parcelas = Array.from(pre.parcelas, (p, i) => {
        if (!p || typeof p !== 'object') throw new Error(`Parcela ${i + 1} inválida.`);
        const valor = centavosDigitados(p.valor);
        if (valor === 0n) throw new Error(`Informe um valor positivo para a parcela ${i + 1}.`);
        const codigo = p.codBarraPIX;
        if (
            codigo != null &&
            codigo !== '' &&
            (typeof codigo !== 'string' || !codigo.trim() || codigo.length > 4096 || /[\u0000-\u001f\u007f-\u009f]/.test(codigo))
        ) {
            throw new Error(`Código de barras / chave PIX inválido na parcela ${i + 1}.`);
        }
        return { valor: decimalFinanceiro(valor), dataVencimento: dataFinanceira(p.dataVencimento), codBarraPIX: codigo || null };
    });
    const r = resumirParcelas(parcelas, movimento.totalValor);
    if (r.total <= 0n || r.diferenca !== 0n)
        throw new Error('A soma das parcelas deve ser igual ao total do Movimento. Confira a aba Lançamentos.');
    return { versao: 1, parcelas };
}
